import type { HouseholdStage } from './generated/gql-enums';

export const HOUSEHOLD_STAGE_LEAD = 'lead' satisfies HouseholdStage;
export const HOUSEHOLD_STAGE_PROSPECTING = 'prospecting' satisfies HouseholdStage;
export const HOUSEHOLD_STAGE_DISCOVERY = 'discovery' satisfies HouseholdStage;
export const HOUSEHOLD_STAGE_DISQUALIFIED = 'disqualified' satisfies HouseholdStage;
export const HOUSEHOLD_STAGE_PROPOSAL = 'proposal' satisfies HouseholdStage;
export const HOUSEHOLD_STAGE_COMMITMENT = 'commitment' satisfies HouseholdStage;
export const HOUSEHOLD_STAGE_ONBOARDING = 'onboarding' satisfies HouseholdStage;
export const HOUSEHOLD_STAGE_ON_HOLD = 'on_hold' satisfies HouseholdStage;
export const HOUSEHOLD_STAGE_INACTIVE = 'inactive' satisfies HouseholdStage;
export const HOUSEHOLD_STAGE_LOST = 'lost' satisfies HouseholdStage;
export const HOUSEHOLD_STAGE_WON = 'won' satisfies HouseholdStage;

export const ALL_HOUSEHOLD_STAGES = [
  HOUSEHOLD_STAGE_LEAD,
  HOUSEHOLD_STAGE_PROSPECTING,
  HOUSEHOLD_STAGE_DISCOVERY,
  HOUSEHOLD_STAGE_DISQUALIFIED,
  HOUSEHOLD_STAGE_PROPOSAL,
  HOUSEHOLD_STAGE_COMMITMENT,
  HOUSEHOLD_STAGE_ONBOARDING,
  HOUSEHOLD_STAGE_ON_HOLD,
  HOUSEHOLD_STAGE_LOST,
  HOUSEHOLD_STAGE_WON,
] satisfies HouseholdStage[];

export const HOUSEHOLD_PROSPECTING_STAGES = [
  HOUSEHOLD_STAGE_LEAD,
  HOUSEHOLD_STAGE_PROSPECTING,
  HOUSEHOLD_STAGE_DISCOVERY,
  HOUSEHOLD_STAGE_PROPOSAL,
  HOUSEHOLD_STAGE_COMMITMENT,
  HOUSEHOLD_STAGE_ONBOARDING,
] satisfies HouseholdStage[];
